import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLFormElement> {
  static override targets = ['triggerElement', 'toolTipMask']

  declare readonly triggerElementTarget: HTMLElement
  declare readonly toolTipMaskTarget: HTMLElement

  closeModal() {
    this.toolTipMaskTarget?.classList.remove('TooltipPlatinum__active')
  }

  handleClick() {
    const triggerElementId: any = this.triggerElementTarget.getAttribute('data-trigger-element-id')
    const tooltipPlatinumShow: any = document.getElementById(triggerElementId)

    tooltipPlatinumShow.addEventListener('click', () => {
      this.toolTipMaskTarget?.classList.add('TooltipPlatinum__active')
    })
  }

  override connect() {
    this.handleClick()
  }
}
